import React from 'react'
import '@styles/loader.css'

const Loader = ({ loading, message, contained = false }) =>
  loading ? (
    <div className={`loader-container${contained ? ' loader-container--contained' : ''}`}>
      <div className='loader-spinner' role='status' aria-live='polite' aria-label='Loading' />
      <span className='loader-message'>
        {message ?? loading?.initialCaps?.()}
      </span>
    </div>
  ) : null

export default Loader
